<template>
  <section class="form-section">
    <header class="form-section-head">
      <h5 class="form-section-title">{{ title }}</h5>
      <p v-if="description" class="form-section-desc">{{ description }}</p>
    </header>
    <slot />
  </section>
</template>

<script>
// One titled card of the job form. Every group of fields uses this so the
// headings, spacing and surface are identical down the whole page.
export default {
  name: 'JobFormSection',

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
// Same resting card as the job pages' `.job-panel` (DESIGN.md: 10px radius,
// faint blue-tinted shadow).
.form-section {
  background: #fff;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0px 10px 25px #00429d0d;
}

.form-section-head {
  margin-bottom: 1.25rem;
  padding-bottom: 0.9rem;
  border-bottom: 1px solid #e5e7eb;
}

.form-section-title {
  margin: 0;
  font-weight: 700;
  color: #111827;
}

.form-section-desc {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
  color: #6b7280;
}
</style>
